// src/components/ui/calendar/core/CalendarDateHeader/CalendarDateHeader.jsx
import React from 'react';
import { cn } from '../../../../../utils/cn';

const CalendarDateHeader = ({
  date,
  view = 'week', // 'week', 'month', 'day'
  isToday = false,
  isSelected = false,
  isCurrentMonth = true,
  showWeekday = true,
  className = ''
}) => {
  // View-specific configurations
  const viewConfig = {
    week: {
      container: 'h-12 p-2 text-center flex items-center justify-center gap-2',
      weekday: 'text-xs font-medium text-slate-400',
      date: 'text-xs font-bold w-6 h-6 rounded flex items-center justify-center transition-all duration-200'
    },
    month: {
      container: 'text-center',
      weekday: 'text-xs font-medium text-slate-400 mb-1',
      date: 'text-xs font-semibold w-6 h-6 rounded flex items-center justify-center transition-all duration-200'
    },
    day: {
      container: 'h-12 p-2 text-center flex items-center justify-center gap-2',
      weekday: 'text-xs font-bold text-white uppercase tracking-wider',
      date: 'text-xs font-bold w-6 h-6 rounded-lg flex items-center justify-center transition-all duration-200'
    }
  };

  const config = viewConfig[view];

  // Date number styling based on state
  const getDateStyles = () => {
    if (isToday) {
      return "bg-blue-600 text-white shadow-xl shadow-blue-500/25";
    }
    if (isSelected) {
      return "bg-slate-600 text-slate-200";
    }
    if (isCurrentMonth) {
      return "text-slate-300 bg-slate-700/30";
    }
    return "text-slate-500 bg-slate-800/20";
  };

  // Get weekday name
  const getWeekdayName = () => {
    if (view === 'day') {
      return date.toLocaleDateString('en-US', { weekday: 'long' });
    }
    return date.toLocaleDateString('en-US', { weekday: 'short' });
  };

  return (
    <div className={cn(config.container, className)}>
      {/* Weekday name */}
      {showWeekday && (
        <div className={config.weekday}>
          {getWeekdayName()}
        </div>
      )}

      {/* Date number */}
      <div className={cn(
        config.date,
        getDateStyles()
      )}>
        {date.getDate()}
      </div>
    </div>
  );
};

export default CalendarDateHeader;